import { IconHeading1Outline18 as Heading1 } from "nucleo-ui-outline-18"

import { ShortcutSymbols } from "@productlane/lib/src/shortcut-symbols"

import type { SlashCommandDefinition } from "../types"
import { iconClassName } from "../constants"

export const heading1Command: SlashCommandDefinition = {
	key: "heading1",
	title: "Heading 1",
	icon: <Heading1 strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor
			.chain()
			.focus()
			.deleteRange(range)
			.setNode("heading", { level: 1 })
			.run()
	},
	group: "headings",
	shortcutIcons: [
		ShortcutSymbols.CTRL,
		ShortcutSymbols.SHIFT,
		ShortcutSymbols[1],
	],
}
